import React, { Component } from 'react'
import { connect } from 'react-redux'
import Modal from 'react-modal'
import * as properties from '../constants/Properties'
import Ink from 'react-ink'
import PropTypes from 'prop-types'

class SplashModal extends Component {
  constructor(props) {
    super(props);
    this.handleTouchTap = this.handleTouchTap.bind(this);
  }

  componentDidMount() {
    Modal.setAppElement('body');
  }

  handleTouchTap(e) {
    e.preventDefault();
    this.props.retryHandel();
  }
  close() {
    window.open('', '_self').close();
  }

  render() {
    let loading = <div className="loading"></div>;
    if (this.props.splashModal.retry) {
      loading = (
        <button className="splashModalRetryButton" onClick={this.handleTouchTap}>
          <i className="repeat icon"></i>
          <Ink />
        </button>
      )
    }

    let close;
    if (this.props.splashModal.retry) {
      close = (
        <button className="splashModalHeaderButton" onClick={this.close}>
          <i className="close icon"></i>
          <Ink />
        </button>
      )
    }

    return (
      <Modal className="splashModal"
        contentLabel=""
        isOpen={this.props.splashModal.show}
        style={properties.splashModalStyle}
      >
        <div className="splashModalContent">
          <div className="splashModalHeader">
            {close}
          </div>
          <div className="splashModalBody">
            <div className="splashModalMessage">
              {this.props.splashModal.message}
            </div>
            <div className="splashModalLoader">
              {loading}
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

SplashModal.propTypes = {
  splashModal: PropTypes.object.isRequired,
  retryHandel: PropTypes.func
}
function mapStateToProps(state) {
  return {
    splashModal: state.generalState.modal.splashModal
  }
}

export default connect(mapStateToProps)(SplashModal)



// WEBPACK FOOTER //
// src/components/SplashModal.jsx